import React from "react";
import { useForm } from "react-hook-form";
import { Constants, Trk } from "../../../../constants";
import { UpsellPanelSteps } from "../../../../constants/upsellPanelEnumsAndConstants";
import { useUpsellWidgetContainer } from "../../hooks/useUpsellWidgetContainerContext";
import { useUpsellWidgetModel } from "../../hooks/useUpsellWidgetModelContext";
import { useUpsellWidgetSMSTokenTimerContext } from "../../hooks/useUpsellWidgetSMSTokenTimerContext";
import { useUpdateSubscriberPhoneNumberMutation } from "../../services/hooks/useMFAMutations";
import { MobilePhoneInput } from "./FormControls";
import { RequestSMSCode } from "./FormControls/RequestSMSCode";

export const Step4MobileUpdate = () => {
  const model = useUpsellWidgetModel();
  const { currentStep, goToStep, baseProps, updateBaseProps, boldClass, handleErrorResponse, onSubmitError, setIsUpsellContainerLoading } = useUpsellWidgetContainer();
  const { resetTimer, remainingTime, getRemainingTimeText } = useUpsellWidgetSMSTokenTimerContext();

  if (currentStep !== UpsellPanelSteps.Step4MobileUpdate) {
    return null;
  }

  const { mutate: updateMobileNumber } = useUpdateSubscriberPhoneNumberMutation();

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch
  } = useForm();

  const dayPhone = watch('dayPhone');


  const handleLoginSuccess = (response) => {
    resetTimer();
    if (response.status === Constants.RequestStatus.SUCCESS) {
      updateBaseProps({
        twilioStatusModel: {
          status: response.twilioStatus,
          failed: response.twilioFailed
        }
      });
      goToStep(UpsellPanelSteps.Step2SMSToken);
      setIsUpsellContainerLoading(false);
    } else if (response.errors) {
      handleErrorResponse(response.errors, setFormErrors);
      setIsUpsellContainerLoading(false);
    }
  }

  const onSubmit = (formData) => {
    if (remainingTime === 0) {
      setIsUpsellContainerLoading(true);
      AnalyticsTrack(Trk.ACCOUNT.MOBILE_VERIFICATION_SENT,
        {
          category: "account",
          action: "mobile_verification_sent"
        });
      const userMobile = formData?.dayPhone || dayPhone;
      updateBaseProps({
        user: {
          ...baseProps.user,
          mobile: userMobile
        }
      });
      updateMobileNumber({
        dayPhone: userMobile,
        targetBuid: model.targetBuid
      }, {
        onSuccess: handleLoginSuccess,
        onError: (error) => onSubmitError(error)
      });
    }
  };

  return (
    <div className="step4">
      <form
        className="join-form-inline form-is-custom form-disable-pristine-error"
        noValidate
      >
        <div className="row">
          <div className="col-12">
            <MobilePhoneInput register={register} errors={errors} name='dayPhone' />
          </div>

          {/* Request MFA Code Button */}
          <RequestSMSCode
            btnText='Send verification code'
            btnCss={`btn btn-primary btn-fw btn-brand-style-with-pad-sm font-19-no-line-height pt-2 ${boldClass}`}
            remainingTime={remainingTime}
            getRemainingTimeText={getRemainingTimeText}
            onRequestTokenClick={handleSubmit(onSubmit)}
          />
        </div>
      </form>
    </div>
  );
};

